<main class="max-w-4xl mx-auto px-6 pt-8 pb-12 md:pt-12 space-y-12">
  <section class="space-y-4">
    <h1 class="text-2xl font-semibold">Circled Plus -  Privacy Policy</h1>
    <p>This Privacy Policy explains how Circled Proptech LLP, operating Circled Plus, Circled Intelligence (CI) and Circled Advisory (“Circled”, “we”, “us”, “our”), collects, uses, stores and shares personal information in connection with the Platform and Services.</p>
    <p>Certain transaction or brokerage activities may involve Turnip Consultants LLP where it is engaged to provide the applicable real-estate brokerage or transaction-facilitation service.</p>
    <p>We process personal information in accordance with applicable Indian law.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">1. Information We May Collect</h2>
    <h3 class="font-semibold">Information You Provide</h3>
    <p>Depending on how you use Circled Plus, we may collect:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>name;</li>
      <li>email address;</li>
      <li>phone number;</li>
      <li>country or city of residence;</li>
      <li>preferred property locations;</li>
      <li>budget;</li>
      <li>property type and configuration preferences;</li>
      <li>purchase timeline;</li>
      <li>investment, relocation or home-buying objectives;</li>
      <li>information submitted through forms;</li>
      <li>property enquiries;</li>
      <li>saved preferences;</li>
      <li>subscription information; and</li>
      <li>other information you voluntarily provide.</li>
    </ul>
    <h3 class="font-semibold">Communications</h3>
    <p>We may retain information contained in communications with our team through:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>WhatsApp;</li>
      <li>email;</li>
      <li>telephone;</li>
      <li>forms;</li>
      <li>property enquiries; and</li>
      <li>advisory interactions.</li>
    </ul>
    <p>Where permitted by law and operationally applicable, calls or interactions may be recorded or logged for quality, compliance and service purposes with appropriate notice.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">2. Subscription and Payment Information</h2>
    <p>Where you purchase a Subscription, payment processing may be carried out through third-party payment providers.</p>
    <p>Circled may receive information including:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>payment status;</li>
      <li>transaction or order identifier;</li>
      <li>amount;</li>
      <li>selected plan;</li>
      <li>invoice information; and</li>
      <li>subscription start and expiry details.</li>
    </ul>
    <p>Circled does not ordinarily store complete card or banking credentials processed directly by authorised payment gateways.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">3. Platform and Technical Information</h2>
    <p>When you use Circled Plus, we may automatically collect information including:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>IP address;</li>
      <li>browser and device information;</li>
      <li>operating system;</li>
      <li>login/session information;</li>
      <li>pages and properties viewed;</li>
      <li>searches and filters;</li>
      <li>clicks and navigation patterns;</li>
      <li>referral information;</li>
      <li>date/time information;</li>
      <li>approximate location derived from technical information where applicable;</li>
      <li>cookies; and</li>
      <li>analytics or performance information.</li>
    </ul>
    <p>This information may be used to operate, secure and improve Circled Plus.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">4. Circled Intelligence (CI) and Property-Interaction Data</h2>
    <p>Where you use Circled Intelligence (CI), we may process information relating to:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>properties viewed;</li>
      <li>CI assessments accessed;</li>
      <li>search and filter preferences;</li>
      <li>property comparisons;</li>
      <li>subscription/usage limits;</li>
      <li>interaction with reports or property intelligence; and</li>
      <li>advisory requests arising from your use of CI.</li>
    </ul>
    <p>This information may be used to provide the requested service, personalise property discovery, improve Circled Intelligence (CI), understand product usage and support the advisory experience.</p>
    <p>Property market and transaction information used by Circled Intelligence (CI) is not necessarily personal information relating to the user and may originate from third-party or public/property-market sources.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">5. How We Use Personal Information</h2>
    <p>We may use personal information to:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>create and manage your account;</li>
      <li>verify or approve access where applicable;</li>
      <li>provide property discovery services;</li>
      <li>personalise listings and property recommendations;</li>
      <li>provide Circled Intelligence (CI);</li>
      <li>administer subscriptions;</li>
      <li>process and record payments;</li>
      <li>provide customer support;</li>
      <li>schedule property viewings;</li>
      <li>coordinate introductions;</li>
      <li>support property negotiations or transaction discussions where requested;</li>
      <li>communicate service and account updates;</li>
      <li>prevent fraud and misuse;</li>
      <li>secure and improve the Platform;</li>
      <li>analyse Platform performance;</li>
      <li>develop and improve features, products and services;</li>
      <li>comply with law; and</li>
      <li>maintain appropriate business and compliance records.</li>
    </ul>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">6. Sharing with Turnip Consultants LLP</h2>
    <p>Where you request or proceed with services that involve regulated real-estate brokerage or transaction facilitation, relevant personal and property-related information may be shared with Turnip Consultants LLP where necessary to provide those services.</p>
    <p>Such information may include your:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>identity and contact information;</li>
      <li>property enquiry;</li>
      <li>preferences;</li>
      <li>transaction requirements;</li>
      <li>viewing information; and</li>
      <li>transaction-related communications.</li>
    </ul>
    <p>Information will be shared only where reasonably necessary for the relevant service, transaction or lawful business purpose.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">7. Sharing with Property Owners, Developers and Other Parties</h2>
    <p>Where necessary to respond to an enquiry or facilitate a property interaction, we may share relevant information with:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>property owners;</li>
      <li>sellers;</li>
      <li>developers;</li>
      <li>authorised representatives;</li>
      <li>transaction partners;</li>
      <li>legal or professional service providers;</li>
      <li>payment providers;</li>
      <li>technology/service providers; and</li>
      <li>other parties necessary to provide a Service requested by you.</li>
    </ul>
    <p>We seek to limit sharing to information reasonably required for the relevant purpose.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">8. Private Listings and Confidentiality</h2>
    <p>Information relating to Private Listings may contain confidential seller or property information.</p>
    <p>Users receiving such information are separately bound by the confidentiality and Private Listing obligations contained in the Circled Plus Terms &amp; Conditions.</p>
    <p>Circled may monitor access to Private Listings and take reasonable measures to prevent misuse or unauthorised redistribution.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">9. Marketing and Communications</h2>
    <p>Circled may communicate with you through:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>email;</li>
      <li>telephone; and</li>
      <li>WhatsApp.</li>
    </ul>
    <p>Communications may include:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>property opportunities;</li>
      <li>private listing alerts;</li>
      <li>property recommendations;</li>
      <li>Circled Intelligence (CI) information;</li>
      <li>account/subscription information;</li>
      <li>advisory communications; and</li>
      <li>product or service updates.</li>
    </ul>
    <p>Where required, promotional communications will be sent based on the applicable consent or lawful basis.</p>
    <p>You may opt out of promotional communications using the mechanism provided or by contacting us.</p>
    <p>Essential service, account, payment, security or transaction communications may still be sent where permitted by applicable law.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">10. Cookies and Analytics</h2>
    <p>Circled may use cookies and similar technologies for purposes including:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>authentication;</li>
      <li>session management;</li>
      <li>preferences;</li>
      <li>security;</li>
      <li>analytics;</li>
      <li>performance measurement; and</li>
      <li>improving Platform experience.</li>
    </ul>
    <p>Some analytics or technology services may be provided by third parties and may process technical information according to their respective privacy terms.</p>
    <p>Users may manage cookies through available Platform or browser controls, although disabling certain cookies may affect functionality.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">11. Data Accuracy and Retention</h2>
    <p>We seek to maintain personal information that is reasonably accurate for the purposes for which it is used.</p>
    <p>Personal information may be retained for as long as reasonably necessary to:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>provide Services;</li>
      <li>maintain an active account;</li>
      <li>administer subscriptions;</li>
      <li>support transactions;</li>
      <li>meet accounting, tax, regulatory or legal obligations;</li>
      <li>resolve disputes;</li>
      <li>prevent fraud;</li>
      <li>enforce agreements; or</li>
      <li>establish, exercise or defend legal claims.</li>
    </ul>
    <p>Information that is no longer required will be deleted, anonymised or otherwise handled in accordance with applicable law and Circled's retention practices.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">12. Security</h2>
    <p>Circled uses reasonable administrative, technical and organisational measures designed to protect personal information.</p>
    <p>These may include:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>access controls;</li>
      <li>secure infrastructure;</li>
      <li>authentication controls;</li>
      <li>restricted employee access;</li>
      <li>encryption where appropriate;</li>
      <li>monitoring and security procedures.</li>
    </ul>
    <p>No online or electronic system can be guaranteed to be completely secure.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">13. Your Choices and Rights</h2>
    <p>Subject to applicable law, you may contact Circled to:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>request information about personal data held about you;</li>
      <li>request correction of inaccurate information;</li>
      <li>update your details;</li>
      <li>withdraw consent where processing is based on consent;</li>
      <li>request deletion or erasure where legally applicable;</li>
      <li>opt out of promotional communication; or</li>
      <li>raise a privacy grievance.</li>
    </ul>
    <p>Certain information may need to be retained despite a deletion request where required for legal, regulatory, taxation, fraud-prevention, contractual or dispute-related purposes.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">14. Withdrawal of Consent</h2>
    <p>Where we rely on your consent, you may withdraw it by contacting Circled or through any withdrawal mechanism made available on the Platform.</p>
    <p>Withdrawal will apply prospectively and may affect our ability to provide Services that require the relevant information.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">15. Third-Party Platforms and Links</h2>
    <p>Circled Plus may contain links or integrations with third-party websites, platforms or services.</p>
    <p>Their handling of personal information is governed by their own privacy practices and Circled is not responsible for independent third-party privacy policies.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">16. Changes to this Privacy Policy</h2>
    <p>We may update this Privacy Policy to reflect changes in:</p>
    <ul class="list-disc pl-6 space-y-2">
      <li>law;</li>
      <li>technology;</li>
      <li>Platform functionality;</li>
      <li>Circled Intelligence (CI);</li>
      <li>service providers; or</li>
      <li>business operations.</li>
    </ul>
    <p>The latest version will be made available on the Platform together with an updated effective date.</p>
    <p>Where required by applicable law, material changes may be communicated separately.</p>
  </section>

  <section class="space-y-4">
    <h2 class="text-2xl font-semibold">17. Contact and Privacy Grievances</h2>
    <p>For questions, corrections, privacy requests or grievances relating to personal information:</p>
    <p>Circled Proptech LLP</p>
    <p>Operating Circled Plus, Circled Intelligence (CI) and Circled Advisory</p>
    <p>Bengaluru, Karnataka, India</p>
    <p>Email: <a href="mailto:support&#64;circledplus.co.in" class="underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">support&#64;circledplus.co.in</a></p>
    <p>Additional grievance or privacy contact information may be published on the Platform as required by applicable law.</p>
  </section>
</main>
